import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './style';

import filter from '../../utils/filter';

class DetailPart extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  getValue(detail) {
    this.detail = detail;
    if (detail.format && detail.format !== '') {
      if (detail.format === 'html') {
        return (<span style={styles.value} dangerouslySetInnerHTML={{ __html: detail.value }} />);
      }
      return (<span style={styles.value}> {filter(detail.format, detail.value)} </span>);
    }
    return (<span style={styles.value}> {detail.value} </span>);
  }

  render() {
    const { detailList, data } = this.props;

    const comment = detailList.map((detail, idx) => {
      const key = `${idx}-${detail.text}`;
      const items = detail.items || [detail];
      if (detail.isShow) {
        const params = detail.isShowParams.map(p => data[p]);
        if (!detail.isShow(...params)) {
          return null;
        }
      }
      return (
        <div
          key={key}
          style={styles.container}
        >
          <span
            style={styles.text}
          >
            {detail.text}：
          </span>
          {
            items.map((item) => {
              const value = this.getValue(item);
              const after = item.after ? <span style={styles.value}> {item.after} </span> : '';
              const k = `inner-${item.key}`;

              return (
                <div key={k} style={styles.inline}>
                  {value}
                  {after}
                </div>
              );
            })
          }
        </div>
      );
    }
  );
    return (
      <div>
        {comment}
      </div>
    );
  }
}

DetailPart.propTypes = {
  detailList: PropTypes.arrayOf(PropTypes.shape({})),
  data: PropTypes.shape({}),
};

DetailPart.defaultProps = {
  detailList: [],
  data: {}
};

export default DetailPart;



// WEBPACK FOOTER //
// ./src/Parts/DetailPart/index.js